<template>
  <div
    :id="candidate.id"
    class="profile"
  >
    <div class="columns">
      <transition
        name="component-fade"
        mode="out-in"
      >
        <component
          :is="contactView"
          :class="'user-block-'+candidate.id"
          :school="school"
          :school-slug="schoolSlug"
          :candidate="candidate"
          :family="family"
          @send="saveContact"
          @edit="editContact"
        />
      </transition>


      <div :class="[contactEdit ? 'column is-8':'column is-9']">
        <b-collapse
          v-for="app in applicationLog"
          :key="app.id"
          :open="false"
          class="card m-b-md"
        >
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
          >
            <p class="card-header-title">
              <span
                v-if="app.registration && app.registration.registration_accepted"
                class="m-r-sm"
              >
                Inscription
              </span>
              <span
                v-else
                class="m-r-sm"
              >
                Candidature
              </span>
              {{ app.choices[0].scholar_year }}
            </p>
            <a class="card-header-icon">
              <b-icon
                :icon="props.open ? 'chevron-down' : 'chevron-right'"
              />
            </a>
          </div>
          <div class="card-content">
            <div class="content">
              <transition
                name="component-fade"
                mode="out-in"
              >
                <component
                  :is="applicationView"
                  :candidate="candidate"
                  :school="school"
                  :school-slug="schoolSlug"
                  :application="app"
                  :completion="completion"
                />
              </transition>
            </div>
          </div>
        </b-collapse>

        <div class="app-block app-application">
          <transition
            name="component-fade"
            mode="out-in"
          >
            <component
              :is="choiceView"
              :class="'choices-block-'+candidate.id + [!candidate.id ? '  app-disabled':'']"
              :school="school"
              :school-slug="schoolSlug"
              :campuses="campuses"
              :trainings="trainings"
              :choices="choices"
              :candidate="candidate"
              :application="application"
              :completion="completion"
              @send="saveChoices"
              @edit="editChoices"
            />
          </transition>

          <transition
            name="component-fade"
            mode="out-in"
          >
            <component
              :is="applicationDocumentsView"
              class="messages-block"
              :candidate="candidate"
              :application="application"
              :school="school"
              :school-slug="schoolSlug"
            />
          </transition>


          <!--<transition name="component-fade" mode="out-in">
              <component
                      :class="'cursus-block-'+candidate.id + [!candidate.id ? ' app-disabled':'']"
                      :is="curriculumView"
                      :schoolSlug="schoolSlug"
                      :candidate="candidate"
                      v-on:send="saveCurriculum"
                      v-on:edit="editCurriculum"
                      >
              </component>
          </transition>-->

          <div v-if="!isAcceptedApplication() && !candidate.canReregister">
            <transition
              name="component-fade"
              mode="out-in"
            >

              <component
                :is="motivationView"
                :class="'motivation-block-'+candidate.id + [!candidate.id ? ' app-disabled':'']"
                :school="school"
                :school-slug="schoolSlug"
                :candidate="candidate"
                :application="application"
                @send="saveMotivation"
                @edit="editMotivation"
              />
            </transition>
          </div>

          <transition
            name="component-fade"
            mode="out-in"
          >
            <component
              :is="documentsView"
              :class="'documents-block-'+candidate.id + [!candidate.id ? ' app-disabled':'']"
              :school-slug="schoolSlug"
              :candidate="candidate"
              :application="application"
              @send="saveDocuments"
            />
          </transition>

          <div v-if="!isRegisteredCandidate() && !isAcceptedApplication() && !candidate.canReregister && optionHasApplicationFees()">
            <transition
              name="component-fade"
              mode="out-in"
            >
              <component
                :is="feesView"
                :class="'fees-block-'+ candidate.id + [!application.choices_complete || application.choices[0].scholar_year === 'other' ? ' app-disabled':'']"
                :school-object="school"
                :school="schoolSlug"
                :candidate="candidate"
                :application="application"
                :error-fee="errorFee"
                @send="savePayment"
                @edit="editPayment"
              />
            </transition>
          </div>

          <div v-if="!isRegisteredCandidate()">
            <transition
              name="component-fade"
              mode="out-in"
            >
              <component
                :is="processView"
                :class="'process-block-'+ candidate.id + [!candidate.id ? ' app-disabled':'']"
                :school="school"
                :school-slug="schoolSlug"
                :candidate="candidate"
                @send="saveProcessChoice"
                @edit="editProcessChoice"
              />
            </transition>
          </div>


          <transition
            name="component-fade"
            mode="out-in"
          >
            <component
              :is="registrationView"
              v-if="candidate.applications.accepted"
              :class="'registration-block registration-block-' + candidate.id"
              :candidate="candidate"
              :school="school"
              :school-slug="schoolSlug"
            />
          </transition>

          <component
            :is="messageView"
            v-show="isLoaded"
            v-if="candidate"
            :class="'messages-block' + [!candidate.id ? ' app-disabled':'']"
            :candidate="candidate"
            :school-slug="schoolSlug"
            :school="school"
            :candidate-account="candidateAccount"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from 'services/organization'
import ContactForm from '../../components/application/ContactForm.vue'
import Contact from '../../components/application/Contact.vue'
import ChoicesForm from '../../components/application/ChoicesForm.vue'
import ChoicesSchoolsForm from '../../components/application/ChoicesSchoolsForm.vue'
import Choices from '../../components/application/Choices.vue'
import CurriculumForm from '../../components/application/CurriculumForm.vue'
import Curriculum from '../../components/application/Curriculum.vue'
import MotivationForm from '../../components/application/MotivationsForm.vue'
import Motivation from '../../components/application/Motivations.vue'
import FeesForm from '../../components/application/FeesForm.vue'
import Fees from '../../components/application/Fees.vue'
import DocumentsForm from '../../components/application/DocumentsForm.vue'
import ProcessForm from '../../components/application/ProcessForm.vue'
import Process from '../../components/application/Process.vue'
import RegistrationFees from '../../components/application/RegistrationFees.vue'
import Messages from '../../components/application/Messages.vue'
import ApplicationLog from '../../components/application/ApplicationLog'
import {mapActions, mapGetters, mapState} from 'vuex'
import _ from 'lodash'
import ApplicationDocuments from "../../components/application/ApplicationDocuments.vue";

export default {
  props: {
    candidate: {type: Object},
    application: {type: Object}
  },
  data() {
    return {
      isLoaded: false,
      completion: 0,
      contactView: '',
      choiceView: '',
      curriculumView: '',
      motivationView: '',
      feesView: '',
      documentsView: '',
      processView: '',
      registrationView: '',
      messageView: Messages,
      applicationView: ApplicationLog,
      applicationDocumentsView: ApplicationDocuments,
      contactEdit: true,
      choiceEdit: true,
      curriculumEdit: true,
      motivationEdit: true,
      feesEdit: true,
      documentsEdit: true,
      processEdit: true,
      registrationEdit: true,
      choices: [],
      family: {},
      campuses: [],
      trainings: [],
      errorFee: '',
      applicationProcess: ''

    }
  },
  computed: {
    ...mapGetters('candidate', [
      'getCandidateById'
    ]),
    ...mapGetters({
      candidateAccount: 'candidate/getCandidateAccount',
    }),
    ...mapGetters('organization', [
      'getSchoolBySlug'
    ]),
    ...mapState({
      user: 'auth',
      responsive: 'app'
    }),
    registered() {
      return this.application.registration && this.application.registration.registered_candidate
    },
    applicationLog() {
      if (this.candidate.application_log) {
        let applicationLog = this.candidate.application_log.filter(application => application.id !== this.application.id)
        return _.sortBy(applicationLog, 'accepted_date')
      }
    },

    canReregister() {
      return this.candidate.canReregister
    },
    school() {
      return this.getSchoolBySlug(this.$route.params.school)
    },
    schoolSlug() {
      return this.school ? this.school.slug : ''
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'init'
  },
  methods: {
    ...mapActions({
      refreshAccount: 'auth/setAccount',
      logout: 'auth/logout'
    }),
    isRegisteredCandidate() {
      return this.candidate.isRegisteredCandidate
    },
    hasAcceptedApplication() {
      return this.candidate.hasAcceptedApplication
    },
    hasRegisteredApplication() {
      return this.candidate.hasRegisteredApplication
    },
    isAcceptedApplication() {
      return this.candidate.isAcceptedCandidate
    },
    optionHasApplicationFees() {
      if (this.application.choices && this.application.choices[0]) {
        if (!this.application.choices[0].training_option) {
          return false
        }
        return this.application.choices[0] && this.application.choices[0].training_option.application_fee === 1
      }
      return true
    },
    init() {
      this.getCandidate()
      this.checkSchool()
      this.fetchSchoolTrainings()
      if (this.application.choices && this.application.choices[0] && this.school && this.school.slug !== this.application.choices[0].school_slug) {
        this.$router.replace({'path': '/admissioneschool/' + this.choices[0].school_slug + '/mon-compte'})
      }
    },
    notAuthenticated() {
      this.$router.replace({'path': '/admissioneschool/' + this.school.slug + '/connexion'})
      this.logout()
    },
    checkSchool() {
      if (this.school) {
        this.choices.school_id = this.school.id
        this.campuses = this.school.campuses
      } else {
        //this.$router.replace({ 'path': '/admissioneschool' })
      }
    },
    fetchSchoolTrainings: function () {
      if (this.$route.params.school) {
        api.schoolTrainings(this.$route.params.school).then((result) => {
          this.trainings = result.data
        }).catch(e => {
        })
      }
    },

    getCandidate: function () {
      this.completion = 0

      if (this.candidate.account_complete) {
        this.contactView = Contact
        this.contactEdit = false
        this.completion += 20
      } else {
        this.contactView = ContactForm
        this.contactEdit = true
      }

      this.choices = []
      if (this.application.choices && this.application.choices.length > 0) {
        this.choices = this.application.choices
      }
      if (this.application.choices_complete) {
        this.choiceView = Choices
        this.choiceEdit = false
        this.completion += 10
      } else {
        if (this.canReregister) {
          this.choiceView = ChoicesSchoolsForm
        } else {
          this.choiceView = ChoicesForm
        }

        this.choiceEdit = true
      }

      if (this.candidate.curriculum_complete) {
        this.curriculumView = Curriculum
        this.curriculumEdit = false
        this.completion += 10
      } else {
        this.curriculumView = CurriculumForm
        this.curriculumEdit = true
      }

      if (this.application.motivation_complete) {
        this.motivationView = Motivation
        this.motivationEdit = false
        this.completion += 20
      } else {
        this.motivationView = MotivationForm
        this.motivationEdit = true
      }

      if (this.application.fees_complete && this.application.payment_mode !== null) {
        if (this.application.payment_mode === 'CB' && this.application.fees && this.application.fees.code_retour !== 'Annulation') {
          this.feesView = Fees
          this.feesEdit = false
          this.completion += 20
        } else {
          this.feesView = FeesForm
          this.feesEdit = true
        }

        if (this.application.payment_mode !== 'CB') {
          this.feesView = Fees
          this.feesEdit = false
          this.completion += 20
        }

      } else {
        this.feesView = FeesForm
        this.feesEdit = true
      }

      this.documentsView = DocumentsForm
      if (this.application.documents_complete) {
        this.completion += 10
      }

      if (this.application && this.application.process && this.application.process.length) {
        this.processView = Process
        this.processEdit = false
        this.completion += 10
      } else {
        this.processView = ProcessForm
        this.processEdit = true
      }


      this.registrationView = RegistrationFees
      this.registrationEdit = false

    },

    /*
      Contact form components actions
     */
    saveContact: function () {
      this.contactView = Contact
      this.contactEdit = false
      if (!this.candidate.account_complete) {
        this.completion += 20
      }
      this.$scrollTo('.user-block-' + this.candidate.id, {offset: -10}, 500)
      this.isLoaded = true
    },
    editContact: function () {
      this.contactView = ContactForm
      this.contactEdit = true
    },

    /*
      Training form components actions
     */
    saveChoices: function () {
      this.choiceView = Choices
      this.choiceEdit = false
      if (!this.application.choices_complete) {
        this.completion += 10
      }
      this.$scrollTo('.choices-block-' + this.candidate.id, {offset: -100}, 500)
    },
    editChoices: function () {
      if (this.canReregister) {
        this.choiceView = ChoicesSchoolsForm
      } else {
        this.choiceView = ChoicesForm
      }
      this.choiceEdit = true
    },

    saveCurriculum: function () {
      this.curriculumView = Curriculum
      this.curriculumEdit = false
      if (!this.candidate.curriculum_complete) {
        this.completion += 10
      }
      this.$scrollTo('.cursus-block-' + this.candidate.id, {offset: -100}, 500)
    },
    editCurriculum: function () {
      this.curriculumView = CurriculumForm
      this.curriculumEdit = true
    },

    saveMotivation: function () {
      this.motivationView = Motivation
      this.motivationEdit = false
      if (!this.application.motivation_complete) {
        this.completion += 20
      }
      this.$scrollTo('.motivation-block-' + this.candidate.id, {offset: -100}, 500)
    },
    editMotivation: function () {
      this.motivationView = MotivationForm
      this.motivationEdit = true
    },
    saveDocuments() {
      if (!this.application.documents_complete) {
        this.completion += 10
      }
      this.$scrollTo('.documents-block-' + this.candidate.id, {offset: -100}, 500)
    },
    savePayment() {
      this.feesView = Fees
      this.feesEdit = false
      if (!this.application.fees_complete) {
        this.completion += 20
      }
      this.$scrollTo('.fees-block-' + this.candidate.id, {offset: -100}, 500)
    },
    editPayment: function () {
      this.feesView = FeesForm
      this.feesEdit = true
    },
    saveProcessChoice() {
      this.processView = Process
      this.processEdit = false
      if (!this.application.process_complete) {
        this.completion += 10
      }
      this.$scrollTo('.process-block-' + this.candidate.id, {offset: -10}, 500)
    },
    editProcessChoice: function () {
      this.processView = ProcessForm
      this.processEdit = true
    },
    saveRegistration() {
      this.registrationView = RegistrationFees
      this.registrationEdit = false
    }
  },
  mounted() {
    if (!this.candidate.newCandidate) {
      this.refreshAccount().then((result) => {
        this.init()
        this.isLoaded = true
      })
    }
  },
  created() {


    if (this.candidate.newCandidate) {
      this.init()
    } else {

      this.refreshAccount().then((result) => {
        this.init()
        this.isLoaded = true
      })
    }
  }
}
</script>

<style scoped>
.app-application {
  padding-bottom: 10px;
}

.application-procedure {
  font-weight: 600;
}

.school-button-ednh {
  color: #fff;
  background-color: #00b4ec;
}

.school-button-egpn {
  color: #fff;
  background-color: #84b23c;
}

.school-button-coursdiderot {
  color: #fff;
  background-color: #FF9C3F;
}

.school-button-ibs {
  color: #fff;
  background-color: #0067B7;
}

.school-button-ensia {
  color: #fff;
  background-color: #009ee0;
}

</style>
